import { useAuthUser } from "react-auth-kit";
import { buildDeleteOptions, buildGetOptions, buildPostOptions, fetchWithErrorHandling } from "services/FetchUtils";
import { getRegistryURL } from "services/registry/Registry";

export interface IIntegrationTestConfiguration {
  clientBranch: string;
  backendImageId: string;
  activePackageId?: string;
  activeSchemaBranch?: string;
  activeSchemaVersion?: number;
  createdTime: number;
  updatedTime: number;
}

const endpoint = (action: string): string => {
  return `${getRegistryURL()}/v1/registry/integration-test-configuration/${action}`;
};

export const list = async (accessToken: string) => {
  const options = buildGetOptions(accessToken);
  return fetchWithErrorHandling(endpoint("list"), options);
};

export const create = async (
  accessToken: string,
  clientBranch: string,
  backendImageId: string,
  activePackageId?: string,
  activeSchemaBranch?: string,
  activeSchemaVersion?: number,
) => {
  const options = buildPostOptions(accessToken, {
    clientBranch,
    backendImageId,
    activePackageId,
    activeSchemaBranch,
    activeSchemaVersion,
  });
  return fetchWithErrorHandling(endpoint("create"), options);
};

export const update = async (
  accessToken: string,
  clientBranch: string,
  backendImageId: string,
  activePackageId?: string,
  activeSchemaBranch?: string,
  activeSchemaVersion?: number,
) => {
  const options = buildPostOptions(accessToken, {
    clientBranch,
    backendImageId,
    activePackageId,
    activeSchemaBranch,
    activeSchemaVersion,
  });
  return fetchWithErrorHandling(endpoint("update"), options);
};

export const remove = async (accessToken: string, clientBranch: string) => {
  const options = buildDeleteOptions(accessToken);
  return fetchWithErrorHandling(endpoint(`remove/${clientBranch}`), options);
};

export const useIntegrationTestConfigurationService = () => {
  const authUser = useAuthUser();
  const accessToken = authUser()?.access_token;
  return {
    list: () => list(accessToken),
    create: (
      clientBranch: string,
      backendImageId: string,
      activePackageId?: string,
      activeSchemaBranch?: string,
      activeSchemaVersion?: number,
    ) => create(accessToken, clientBranch, backendImageId, activePackageId, activeSchemaBranch, activeSchemaVersion),
    update: (
      clientBranch: string,
      backendImageId: string,
      activePackageId?: string,
      activeSchemaBranch?: string,
      activeSchemaVersion?: number,
    ) => update(accessToken, clientBranch, backendImageId, activePackageId, activeSchemaBranch, activeSchemaVersion),
    remove: (clientBranch: string) => remove(accessToken, clientBranch),
  };
};
